import {
    FETCH_SUB_AGREEMENT_LIST_REQUEST,
    FETCH_SUB_AGREEMENT_LIST_FAILURE,
    FETCH_SUB_AGREEMENT_LIST_SUCCESS,
    CREATE_SUB_AGREEMENT_REQUEST,
    CREATE_SUB_AGREEMENT_SUCCESS,
    CREATE_SUB_AGREEMENT_FAILURE,
    UPDATE_SUB_AGREEMENT_REQUEST,
    UPDATE_SUB_AGREEMENT_SUCCESS,
    UPDATE_SUB_AGREEMENT_FAILURE,
  } from "../../../actions/manage-property/property-agreement/types";
  
  const initialState = {
    createSubAgreement: { loading: false, data: null, error: null },
    deleteSubAgreement: { loading: false, data: null, error: null },
    updateSubAgreement: { loading: false, data: null, error: null },
    subAgreementList: { loading: false, data: null, error: null },
  };
  
  const SubAgreement = (state = initialState, action) => {
    // console.log("Sub======"+ action.type);
    switch (action.type) {
      //  Request
      case CREATE_SUB_AGREEMENT_REQUEST:
        return {
          ...state,
          createSubAgreement: { ...initialState.createSubAgreement, loading: true },
        };
      case UPDATE_SUB_AGREEMENT_REQUEST:
        return {
          ...state,
          updateSubAgreement: { ...initialState.updateSubAgreement, loading: true },
        };
      case FETCH_SUB_AGREEMENT_LIST_REQUEST: {
        return {
          ...state,
          subAgreementList: { ...initialState.subAgreementList, loading: true },
        };
      }
  
  // Success 
      case CREATE_SUB_AGREEMENT_SUCCESS: {
        // console.log(state.subAgreementList);
        return {
          ...state,
          createSubAgreement: {
            ...state.createSubAgreement,
            payload: action.payload,
            loading: false,
            error: null,
          },
          subAgreementList: addNewSubAgreementData(action.payload, {
            ...state.subAgreementList,
          }),
        };
      }
  
      case UPDATE_SUB_AGREEMENT_SUCCESS: {
        return {
          ...state,
          updateSubAgreement: {
            ...state.updateSubAgreement,
            loading: false,
            error: null,
            payload: action.payload,
          },
          subAgreementList: updateSubAgreementData(action.payload, {
            ...state.subAgreementList,
          }),
        };
      }
  
      case FETCH_SUB_AGREEMENT_LIST_SUCCESS: {
        // console.log(action.payload);
        return {
          ...state,
          subAgreementList: {
            ...initialState.subAgreementList,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
      }
  
      //failure
      case FETCH_SUB_AGREEMENT_LIST_FAILURE:
        return {
          ...state,
          subAgreementList: { data: null, loading: false, error: action.error },
        };
        case CREATE_SUB_AGREEMENT_FAILURE:
          return {
            ...state,
            createSubAgreement: { data: null, loading: false, error: action.error }
          };
        case UPDATE_SUB_AGREEMENT_FAILURE:
          return {
            ...state,
            updateSubAgreement: { data: null, loading: false, error: action.error }
          };
  
      default:
        return state;
    }
  };
  
  function updateSubAgreementData(dataToUpdate, state) {
    state.data.data = state.data.data.map((obj) => {
      if (obj._id !== dataToUpdate._id) return obj;
      return { ...dataToUpdate };
    });
  
    return state;
  }
  
  
  function addNewSubAgreementData(dataToUpdate, state) {
    state.data.data = [...state.data.data, dataToUpdate];
    state.data.total++;
    return state;
  }
  
  export default SubAgreement;
  